<template>
	<div class="cancel">
		<!-- 导航栏 -->
		<topHead>
			<h3 slot="header">补卡申请</h3>
		</topHead>
		<!-- 内容 -->
		<div class="main">
			<div class="ipt">
				<p>身份证号</p>
				<input type="text" maxlength="18" v-model="idCard" placeholder="请输入身份证号" />
			</div>
			<div class="ipt">
				<p>姓名</p>
				<input type="text" maxlength="10" v-model="name" placeholder="请输入您的姓名" />
			</div>
			<span class="hint">注意：补卡费由话费余额中扣除，快递费顺丰到付。</span>
			<van-button round type="info" @click="cancelHeadler">下一步</van-button>
		</div>
		<!-- 加载中 -->
		<load :load="load">
			<p slot="text" class="loadText">结果查询中...</p>
		</load>
		<!-- 失败 -->
		<fail :fail="fail" @headler="failHeadler()"></fail>
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex"
	import API from "../../../common/api/api"
	import topHead from "../../../components/topHead.vue"
	import load from "../../../components/load.vue"
	import fail from "../../../components/fail.vue"
	import {
		Toast
	} from 'vant'
	import FaceAuth from "../../../common/FaceAuth"
	import Lanmao from "../../../components/lanmao/index"
	export default {
		name: "changeCard",
		data() {
			return {
				//上传内容
				idCard: "",
				name: "",
				//类型
				type: "FACE_AUTH",
				//加载中
				load: false,
				//失败
				fail: false,

				paths: "",
			}
		},
		computed: {
			...mapState(["member"]),
		},
		methods: {
			// 查询校验结果
			//上传信息
			cancelHeadler() {
				// console.log(this.member.mobilePhoneInfo.callBalance > 0, this.member.mobilePhoneInfo.callBalance)
				// if (this.member.mobilePhoneInfo.callBalance >= 5) {
					let options = {
						type: "CHANGE_CARD",
						idCard: this.idCard,
						name: this.name
					}
					FaceAuth.start(options)
				// } else {
				// 	Toast({
				// 		message: '你当前余额小于5元，请先交费',
				// 		position: 'bottom'
				// 	})
				// }
			},
			//子传父
			failHeadler() {
				this.fail = false
			}
		},
		components: {
			topHead,
			load,
			fail,
		},
	}
</script>

<style lang="scss" scoped>
	.main {
		padding: 0 px2rem(30);
	}

	.hint {
		font-size: px2rem(24);
		color: #909198;
	}

	.ipt {
		position: relative;
		width: 100%;
		height: px2rem(100);
		background-color: #f6f6f6;
		border-radius: px2rem(18);
		margin-top: px2rem(30);
		font-size: px2rem(26);
		padding: 0 px2rem(30);
		box-sizing: border-box;
	}

	.ipt input {
		width: 100%;
		height: px2rem(100);
		text-align: right;
	}

	.ipt p {
		position: absolute;
		left: px2rem(30);
		top: 0;
		height: px2rem(100);
		line-height: px2rem(100);
	}

	.van-button {
		display: flex;
		justify-content: center;
		text-align: center;
		width: px2rem(550);
		height: px2rem(80);
		line-height: px2rem(80);
		color: #4d4d4d;
		font-weight: bold;
		font-size: px2rem(28);
		background-color: #ffff1a;
		margin: px2rem(90) auto 0;
		box-shadow: 0 0 px2rem(10) rgba($color: #000000, $alpha: 0.2);
	}
</style>
